/*
 * Sign-out request and account cleanup shared by navigation and consent dialogs.
 * Used by SignOut and the Code-of-Conduct dialog when the user declines the agreement.
 * Preserves the dispatched authentication result while callers supply progress and error UI.
 * Example: await runSignOut({ context, onSuccess: leaveAccount, onError: showError });
 */

import { LOGOUT_OUTCOME } from '../../runtime/auth.js';
import { servicesContext } from '../../runtime/services.js';

export async function runSignOut({
  context,
  onStart = () => {},
  onSuccess,
  onExpired = () => {},
  onError
}) {
  context = servicesContext(context, ['auth', ...(!onError ? ['toasts'] : [])]);
  const { logout, getToken } = context.services.auth;
  onSuccess ||= () => context.window.navigate('/');
  onError ||= (error) => context.services.toasts.show({ type: 'error', message: error.message });
  try {
    onStart();
    const outcome = await logout();
    if (getToken()) return;
    if (outcome === LOGOUT_OUTCOME.LOGGED_OUT) onSuccess();
    else if (outcome === LOGOUT_OUTCOME.SESSION_EXPIRED) onExpired();
  } catch (error) {
    onError(error);
  }
}
